// extracted by mini-css-extract-plugin
export default {"standaloneMathLive":"standaloneMathLive_standaloneMathLive__36yp0"};